import React from "react"
import styled from "styled-components"

// UI
import {Col} from "@uprise/grid"
import {H4, H2} from "@uprise/headings"
import {Medium} from "@uprise/text"

const WellbeingScore = ({heading, score, date, text, isStress = false}) => {
	const Block = styled.div`
		background: ${props => (props.isStress ? "rgba(255, 237, 213, 0.5)" : "#f6f4fc")};
		border-radius: 10px;
		box-shadow: inset 1px -2px 0 0 #edeafa;
		padding: 30px 0;
	`

	return (
		<Col className='col-6 col-lg-6 col-md-6 col-sm-12'>
			<Block isStress={isStress}>
				<H4>{heading}</H4>
				<Medium>Last Checked - {date}</Medium>
				<H2 className='m-t-2 m-b-2'>{`${score}%`}</H2>
				<Medium>{text}</Medium>
			</Block>
		</Col>
	)
}

export default WellbeingScore
